/**
 * Resizes an image to the specified width and height
 * @param {HTMLImageElement} image - The original image element
 * @param {number} targetWidth - The target width in pixels
 * @param {number} targetHeight - The target height in pixels
 * @param {HTMLCanvasElement} canvas - The canvas element to use for resizing
 * @returns {Promise<string>} - Promise resolving to the resized image data URL
 */
export const resizeImage = (image, targetWidth, targetHeight, canvas) => {
  return new Promise((resolve, reject) => {
    try {
      // Set canvas dimensions to the target size
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      
      // Draw the image at the new dimensions
      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, targetWidth, targetHeight);
      
      // Convert to data URL
      const dataUrl = canvas.toDataURL('image/png');
      resolve(dataUrl);
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * Calculate the new dimensions while maintaining aspect ratio
 * @param {number} originalWidth - The original width
 * @param {number} originalHeight - The original height
 * @param {number} targetWidth - The desired width
 * @param {number} targetHeight - The desired height
 * @returns {Object} - Object with calculated width and height
 */
export const calculateDimensions = (originalWidth, originalHeight, targetWidth, targetHeight) => {
  const aspectRatio = originalWidth / originalHeight;
  
  if (targetWidth && !targetHeight) {
    // If only width is specified
    return {
      width: targetWidth,
      height: Math.round(targetWidth / aspectRatio)
    };
  } else if (!targetWidth && targetHeight) {
    // If only height is specified
    return {
      width: Math.round(targetHeight * aspectRatio),
      height: targetHeight
    };
  } else {
    // Both width and height specified
    return {
      width: targetWidth,
      height: targetHeight
    };
  }
}; 